/**
 * Define constants for mutations here so that there is a central store of what they are
 */
const path = 'widgets/events/';
export const ADD_EVENTS = `${path}ADD_EVENTS`;
export const SET_FILTER_LIMIT = `${path}SET_FILTER_LIMIT`;
export const SET_MAX_QUERY_SIZE = `${path}SET_MAX_QUERY_SIZE`;
export const SET_STATUS = `${path}SET_STATUS`